import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "Mail__row-content" }
const _hoisted_2 = { key: 1 }

import { PropType } from "vue";
import { Mail } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'MailReceiver',
  props: {
    mail: {
        type: Object as PropType<Mail>,
        required: true,
    },
    canEdit: {
        type: Boolean,
        required: true,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "Mail__label" }, "Aan", -1)),
    _createElementVNode("div", _hoisted_1, [
      (__props.canEdit)
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 0,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.mail.receiver) = $event)),
            type: "text"
          }, null, 512)), [
            [_vModelText, __props.mail.receiver]
          ])
        : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.mail.receiver), 1))
    ])
  ], 64))
}
}

})